import { render, staticRenderFns } from "./SystemDashboard.vue?vue&type=template&id=bd2e1510&scoped=true"
import script from "./SystemDashboard.vue?vue&type=script&lang=js"
export * from "./SystemDashboard.vue?vue&type=script&lang=js"
import style0 from "./SystemDashboard.vue?vue&type=style&index=0&id=bd2e1510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2e1510",
  null
  
)

export default component.exports